import {shouldShowMaybeRSVPFilter} from '~/common/utils/event_utils';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';

const GuestRsvpButton = ({rsvpStatus, setWipRsvpStatus, setRsvpOverlayOpen}) => (
  <Button
    variant="primary"
    fullWidth
    data-qa-id={`response-${rsvpStatus.toLowerCase()}-rsvp`}
    size="large"
    className="view-invitation__rsvp-cta"
    onClick={() => {
      setWipRsvpStatus(rsvpStatus);
      setRsvpOverlayOpen(true);
    }}
  >
    {rsvpStatus}
  </Button>
);

const GuestRsvpOriginalButtons = ({
  setWipRsvpStatus,
  setRsvpOverlayOpen,
  origin,
  allowMaybeRSVPs,
}) => (
  <>
    <GuestRsvpButton
      rsvpStatus="Yes"
      setWipRsvpStatus={setWipRsvpStatus}
      setRsvpOverlayOpen={setRsvpOverlayOpen}
    />
    {shouldShowMaybeRSVPFilter({origin, allowMaybeRSVPs, maybeRSVPCount: null}) && (
      <GuestRsvpButton
        rsvpStatus="Maybe"
        setWipRsvpStatus={setWipRsvpStatus}
        setRsvpOverlayOpen={setRsvpOverlayOpen}
      />
    )}
    <GuestRsvpButton
      rsvpStatus="No"
      setWipRsvpStatus={setWipRsvpStatus}
      setRsvpOverlayOpen={setRsvpOverlayOpen}
    />
  </>
);

export const GuestRsvpActions = ({
  hasRsvpd,
  setUpdatingRsvp,
  setWipRsvpStatus,
  setRsvpOverlayOpen,
  origin,
  allowMaybeRSVPs,
}) => (
  <div className="view-invitation__rsvp-handler">
    <Typography variant="label2" size="large" classNames="view-invitation__rsvp-heading">
      Will you be attending?
    </Typography>
    <div className="view-invitation__rsvp-cta-group">
      <GuestRsvpOriginalButtons
        origin={origin}
        setRsvpOverlayOpen={setRsvpOverlayOpen}
        setWipRsvpStatus={setWipRsvpStatus}
        allowMaybeRSVPs={allowMaybeRSVPs}
      />
    </div>
    {hasRsvpd && (
      <Button
        variant="unstyled-button"
        data-qa-id="cancel-rsvp-change"
        className="unstyled-button link"
        onClick={() => setUpdatingRsvp(false)}
      >
        Cancel
      </Button>
    )}
  </div>
);
